var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-input", {
    attrs: { placeholder: _vm.placeholder, value: _vm.inputVal },
    on: { input: _vm.backValue },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }